import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';

import { AppSettings } from '../../../../app.settings';
import { Settings } from '../../../../app.settings.model';
import { Question } from '../../../../_models';
import { FileType } from '../../../../_enums';
import { MinValidator } from 'src/app/_validators';

@Component({
  selector: 'app-question-type-upload-document',
  templateUrl: './question-type-upload-document.component.html',
  styleUrls: ['./question-type-upload-document.component.scss']
})
export class QuestionTypeUploadDocumentComponent implements OnInit {

  @Input('question') question: Question;
  @Input('formGroup') formGroup: FormGroup; settings: Settings;
  @Input('viewOnly') viewOnly = false;
  FileType = FileType;
  constructor(
    private fb: FormBuilder,
    public appSettings: AppSettings,
  ) {
    this.settings = this.appSettings.settings;
  }

  get fileSize() {
    return this.formGroup ? this.formGroup.get('fileSize') : null;
  }

  get fileTypes() {
    return this.formGroup ? this.formGroup.get('fileTypes') : null;
  }

  ngOnInit() {
    this.formGroup.addControl('fileSize',
      this.fb.control(this.question ? this.question.fileSize : '', [MinValidator.getMinValidator(1)]));

    this.formGroup.addControl('fileTypes',
      this.fb.control(this.question ? this.question.fileTypes : ''));

    if (this.viewOnly)
      this.formGroup.disable();
  }

  fileTypeChange(type: FileType, checked) {
    let val = +this.fileTypes.value;
    // tslint:disable-next-line:no-bitwise
    val = checked ? (val |= type) : (val &= ~type);
    this.fileTypes.setValue(val);
  }
  isFileTypesContainType(type: FileType): boolean {
    if (this.fileTypes)
      // tslint:disable-next-line:no-bitwise
      return (+this.fileTypes.value & type) === type;
    return false;
  }
}
